import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const MainContainer = styled.div`
    position: absolute;
    right: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    overflow: hidden;
    align-self: baseline;
`;

export const ChangeButtonWrapperV1 = styled.div`
    margin: 0 8px 1px 0;
    overflow: hidden;
`;

export const ChangePaymentCtaContainerV1 = styled(Text)(({ theme }) => ({
    background: `linear-gradient(275deg, ${theme.colors[theme.colorMode].background_Primary} 91.1%, ${theme.colors[theme.colorMode].background_Primary} 99.27%)`,
    whiteSpace: "nowrap",
    paddingLeft: "12px",
}));

export const ChevronContainer = styled.div(({ theme }) => ({
    display: "flex",
    marginTop: `calc(${theme.spacing.xxxSmall} * -1)`,
}));
